module.exports = __webpack_public_path__ + "media/images/pc/plans/search_form/location_type_studio@3x-dd4b09c4938c631f1b93565908da75b4.webp";